import React, { useContext, useState } from 'react';
import { firestore } from '../Firebase';
import { useParams } from 'react-router-dom';
import { serverTimestamp } from 'firebase/firestore';
import { AuthContextPublic } from '../context/AuthContextPublic';
import toast, { Toaster } from 'react-hot-toast';
import { buildQuestionPayload } from '../utils/questions';

const QuestionBox = ({ features = {} }) => {
  const [questionInput, setQuestionInput] = useState('');
  const { videoID: paramVideoID } = useParams();
  const { userName } = useContext(AuthContextPublic) || {};

  const handleSendQuestion = async () => {
    if (!questionInput.trim()) return;
    try {
      await firestore
        .collection('videos')
        .doc(paramVideoID)
        .collection('questions')
        .add(
          buildQuestionPayload({
            text: questionInput,
            userName,
            isAnonymous: features.hasAnonymousQuestions,
            timestamp: serverTimestamp(),
          })
        );

      toast.success(`Question submitted: ${questionInput}`);
      setQuestionInput('');
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  return (
    <div className="question-box-container">
      <Toaster />
      <h5 className={features.hasDarkModeOn ? 'text-white' : ''}>
        Question Box
      </h5>
      <div className="input-area" style={styles.inputArea}>
        <div style={styles.inputWrapper}>
          <textarea
            placeholder="Type a question..."
            style={{
              ...styles.input,
              backgroundColor: features.hasDarkModeOn ? '#343a40' : '#fff',
              color: features.hasDarkModeOn ? '#e9ecef' : 'inherit',
              borderColor: features.hasDarkModeOn ? '#495057' : '#ccc',
            }}
            value={questionInput}
            onChange={(e) => setQuestionInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSendQuestion();
              }
            }}
          />
          <button
            style={{
              ...styles.button,
              backgroundColor: features.hasDarkModeOn ? '#0d6efd' : '#0d6efd',
            }}
            onClick={handleSendQuestion}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  inputArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  inputWrapper: {
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  input: {
    flex: 1,
    padding: '3px 6px',
    borderRadius: '4px 0 0 4px',
    border: '1px solid #ccc',
    borderRight: 'none',
    resize: 'none',
    minHeight: '60px',
    maxHeight: '150px',
    boxSizing: 'border-box',
    width: '0',
    fontSize: '13px',
  },
  button: {
    padding: '8px',
    backgroundColor: '#0d6efd',
    color: '#fff',
    border: 'none',
    borderRadius: '0 4px 4px 0',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontSize: '13px',
  },
};

export default QuestionBox;
